import { Reducer } from 'redux'

import { MyTeamState, MyTeamActionTypes } from './types'

const INITIAL_STATE: MyTeamState = {
  error: false,
  list: [],
  loading: false
}

const reducer: Reducer<MyTeamState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    case MyTeamActionTypes.GET_MY_TEAM:
      return {
        ...state,
        error: false,
        loading: true
      }
    case MyTeamActionTypes.GET_MY_TEAM_SUCCESS:
      return {
        ...state,
        list: payload.list,
        loading: false
      }
    case MyTeamActionTypes.GET_MY_TEAM_FAILURE:
      return {
        ...state,
        error: true,
        list: [],
        loading: false
      }
    default:
      return state
  }
}

export default reducer
